"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable sonarjs/no-duplicate-string */
var React = tslib_1.__importStar(require("react"));
var core_1 = require("@popperjs/core");
var useOnClickOutside_1 = tslib_1.__importDefault(require("../hooks/useOnClickOutside"));
var warning_1 = tslib_1.__importDefault(require("../utils/warning"));
var context_1 = tslib_1.__importDefault(require("./context"));
var PopoverRoot = function (_a) {
    var children = _a.children;
    var _b = tslib_1.__read(React.useState({
        opened: false,
        target: null,
        content: null,
        closedTarget: null,
        timestamp: 0,
        placement: 'auto'
    }), 2), state = _b[0], setState = _b[1];
    var popoverContent = React.useRef(state.content);
    React.useLayoutEffect(function () {
        popoverContent.current = state.content;
    }, [state.content]);
    React.useEffect(function () {
        var _a, _b, _c, _d, _e;
        if (!state.opened) {
            (_b = (_a = popoverContent.current) === null || _a === void 0 ? void 0 : _a.classList) === null || _b === void 0 ? void 0 : _b.remove('hst-popover-opened');
            return undefined;
        }
        if (!state.target || !state.content) {
            (0, warning_1.default)('Popover Root', 'needs target and content');
            return;
        }
        var instance = (0, core_1.createPopper)(state.target, state.content, {
            placement: (_c = state.placement) !== null && _c !== void 0 ? _c : 'auto',
            strategy: 'fixed',
            modifiers: [
                {
                    name: 'offset',
                    options: {
                        offset: [0, 12]
                    }
                }
            ]
        });
        (_e = (_d = popoverContent.current) === null || _d === void 0 ? void 0 : _d.classList) === null || _e === void 0 ? void 0 : _e.add('hst-popover-opened');
        return function () {
            var _a, _b;
            (_b = (_a = popoverContent.current) === null || _a === void 0 ? void 0 : _a.classList) === null || _b === void 0 ? void 0 : _b.remove('hst-popover-opened');
            setTimeout(function () { return instance.destroy(); }, 100);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.opened]);
    (0, useOnClickOutside_1.default)(popoverContent, function () {
        var _a;
        var justOpened = ((_a = Date.now() - state.timestamp) !== null && _a !== void 0 ? _a : 0) < 100;
        if (!state.opened || justOpened)
            return;
        setState(function (currentState) { return (tslib_1.__assign(tslib_1.__assign({}, currentState), { opened: false, closedTarget: currentState.target })); });
        setTimeout(function () {
            setState(function (currentState) { return (tslib_1.__assign(tslib_1.__assign({}, currentState), { closedTarget: null })); });
        }, 300);
    });
    var contextSetValue = React.useCallback(function (newState) {
        setTimeout(function () {
            var resolveNewState = function (currentState) { return (tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, currentState), newState), { timestamp: Date.now(), opened: currentState.closedTarget === newState.target ? false : true })); };
            setState(function (currentState) {
                var waitPreviousclose = !!currentState.closedTarget;
                if (waitPreviousclose) {
                    setTimeout(function () { return setState(resolveNewState); }, 100);
                    return currentState;
                }
                return resolveNewState(currentState);
            });
        }, 0);
        return function () {
            setState(function (currentState) {
                if (currentState.target !== newState.target)
                    return currentState;
                return tslib_1.__assign(tslib_1.__assign({}, currentState), { opened: false });
            });
        };
    }, []);
    var contextValue = React.useMemo(function () { return ({ setState: contextSetValue, openedTarget: state.opened ? state.target : null }); }, [contextSetValue, state.opened, state.target]);
    return (0, jsx_runtime_1.jsx)(context_1.default.Provider, tslib_1.__assign({ value: contextValue }, { children: children }));
};
/**
 * @deprecated Use Popover from Antd
 * https://ant.design/components/popover/
 */
exports.default = PopoverRoot;
